<template>
  <form
    accept-charset="utf-8"
    action="/"
    enctype="application/x-www-form-urlencoded"
    id="login"
    method="post"
    role="form"
  >
    <div class="bg-white border-secondary shadow-sm rounded p-3 h-100 mt-2 mb-2">
      <div class="text-step">
        <h5>
          <span class="badge badge-pill badge-warning mr-3">STEP 2</span>
          <span class="title pt-2 mt-2">ระบุรหัสยืนยัน</span>
        </h5>
        <b-row>
          <b-col rows="12">
            <h6 class="subtitle mt-1">โปรดนำเลขที่ได้รับจาก SMS มากรอกในช่องว่าง</h6>
          </b-col>
        </b-row>
      </div>
      <div class="mt-2">
        <b-row>
          <b-col rows="12" class="text-center">
            <small>รหัสอ้างอิง</small>
          </b-col>
        </b-row>
        <b-row>
          <b-col rows="12" class="text-center code-ref">{{refCode}}</b-col>
        </b-row>
        <b-row>
          <b-col
            rows="12"
            class="d-flex flex-row text-center align-content-center justify-content-center"
          >
            <b-row>
              <b-col class="d-flex">
                <input
                  class="form-control code-input text-center align-self-center bg-white"
                  maxlength="1"
                  v-model="code[0]"
                  @keypress="isNumber"
                  @keyup="goNext($event.target)"
                  readonly
                />
                <input
                  class="form-control code-input text-center align-self-center bg-white"
                  maxlength="1"
                  v-model="code[1]"
                  @keypress="isNumber"
                  @keyup="goNext($event.target)"
                  readonly
                />
                <input
                  class="form-control code-input text-center align-self-center bg-white"
                  maxlength="1"
                  v-model="code[2]"
                  @keypress="isNumber"
                  @keyup="goNext($event.target)"
                  readonly
                />
                <input
                  class="form-control code-input text-center align-self-center bg-white"
                  maxlength="1"
                  v-model="code[3]"
                  @keypress="isNumber"
                  @keyup="goNext($event.target)"
                  readonly
                />
                <input
                  class="form-control code-input text-center align-self-center bg-white"
                  maxlength="1"
                  v-model="code[4]"
                  @keypress="isNumber"
                  @keyup="goNext($event.target)"
                  readonly
                />
                <input
                  class="form-control code-input text-center align-self-center bg-white"
                  maxlength="1"
                  v-model="code[5]"
                  @keypress="isNumber"
                  @keyup="goNext($event.target)"
                  readonly
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="numpad mt-2 d-flex justify-content-center align-content-center">
          <b-col cols="10" md="6" lg="4" class="align-self-center">
            <b-row class="my-3">
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('1')"
                >1</button>
              </b-col>
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('2')"
                >2</button>
              </b-col>
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('3')"
                >3</button>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('4')"
                >4</button>
              </b-col>
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('5')"
                >5</button>
              </b-col>
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('6')"
                >6</button>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('7')"
                >7</button>
              </b-col>
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('8')"
                >8</button>
              </b-col>
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('9')"
                >9</button>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-dark btn-lg btn-block btn-reset-form px-0"
                  type="button"
                  @click="code = ''"
                >
                  <small>ล้างข้อมูล</small>
                </button>
              </b-col>
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block"
                  type="button"
                  @click="numpadClick('0')"
                >0</button>
              </b-col>
              <b-col cols="4" class="px-2">
                <button
                  class="btn btn-outline-primary btn-lg btn-block golden-btn-numpad"
                  type="button"
                  @click="code = code.substring(0, code.length - 1)"
                >
                  <i class="fas fa-backspace"></i>
                </button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p
              class="text-center text-secondary small mt-2"
            >กรุณาใส่หมายเลขโทรศัพท์ที่ระบบได้ส่งไปยังเบอร์โทรศัพท์ของท่านภายใน 5 นาที</p>
          </b-col>
        </b-row>
        <div class="w-100 mt-2 mb-3 border-bottom"></div>
        <b-row>
          <b-col cols="6" class="text-right text-step p-2">
            <small class="text-secondary">ส่งรหัสไปยังเบอร์</small>
            <h5 class="title">
              <i class="fas fa-mobile-alt"></i> {{mobile.substring(0, 8)}}XX
            </h5>
          </b-col>
          <b-col cols="6" class="p-2">
            <b-btn type="button" variant="outline-secondary" size="sm" class="my-3" @clicl="resendOTP">
              <i class="fas fa-sync-alt"></i> ส่งอีกครั้ง
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-card class="bg-secondary border-dark shadow-sm mt-0 p-0 mb-0" body-class="py-1">
      <div class="row">
        <div class="col p-2">
          <router-link class="btn btn-dark btn-block" to="/forgot-password/step-1">
            <i class="fas fa-chevron-left"></i> ย้อนกลับ
          </router-link>
        </div>
        <div class="col p-2">
          <button type="submit" class="btn golden-btn btn-block" @click="register($event)" :disabled="code.length == 6 ? false : 'disabled'">
            &nbsp;&nbsp;&nbsp;ถัดไป
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </b-card>
  </form>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "ForgotPasswordStep2",
  props: ['mobile', 'username', 'refCode'],
  data() {
    return {
      code: ""
    };
  },
  methods: {
    numpadClick(val) {
      if (this.code.length < 6) {
        this.code = this.code + val;
      }
    },
    register(e) {
      e.preventDefault();
      this.$emit('enterOTP', this.code)
      // this.$router.push("/forgot-password/step-3");
    },
    resendOTP() {
      this.$emit('getOTP', this.code);
    },
    isNumber(val) {
      if (isNaN(Number(val.key))) {
        return val.preventDefault();
      }
    },
    goNext(elem) {
      if (elem.value.length == 1) {
        const currentIndex = Array.from(elem.form.elements).indexOf(elem);
        elem.form.elements
          .item(
            currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
          )
          .focus();
      } else if (elem.value.length == 0) {
        const currentIndex = Array.from(elem.form.elements).indexOf(elem);
        elem.form.elements
          .item(
            currentIndex < elem.form.elements.length - 1 ? currentIndex - 1 : 0
          )
          .focus();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.code-input {
  border-color: #bd841b !important;
  width: 40px;
  padding: 0;
  margin: 5px 5px;
  font-size: 25px;
  line-height: 40px;
  height: 40px;
  font-family: SukhumvitBold;
  color: #bd841b !important;
}

.code-ref {
  font-size: 20px;
  letter-spacing: 5px;
}

.numpad {
  .btn {
    font-family: SukhumvitBold;
  }

  .btn-reset-form {
    font-size: 100%;
    line-height: 1.5;
    height: 48px;
  }

  .golden-btn-numpad {
    display: inline-block;
    outline: none;
    /* font-family: inherit; */
    font-family: SukhumvitBold;
    box-sizing: border-box;
    border: none;
    border-radius: 0.2em;
    text-transform: uppercase;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
      inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
    background-image: linear-gradient(
      160deg,
      #a54e07,
      #b47e11,
      #fef1a2,
      #bc881b,
      #a54e07
    );
    border: 1px solid #a55d07;
    color: rgb(120, 50, 5);
    text-shadow: 0 2px 2px rgb(250 227 133);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background-size: 100% 100%;
    background-position: center;
  }
}

.golden-btn {
  display: inline-block;
  outline: none;
  /* font-family: inherit; */
  font-family: SukhumvitBold;
  font-size: 1em;
  box-sizing: border-box;
  border: none;
  border-radius: 0.2em;
  height: auto;
  line-height: 1.9em;
  text-transform: uppercase;
  padding: 3px 0;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
    inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5);
  text-shadow: 0 2px 2px rgb(250 227 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.text-step {
  font-family: SukhumvitBold;

  .title {
    color: rgb(189, 132, 41) !important;
  }
}

.indexlogo {
  width: 100%;
}

.goldpattern {
  background-size: 100%;
  background: url(../../assets/images/gold-pattern.jpg) top center;
}

.select-btn {
  color: #b47e18 !important;
  background-color: white !important;
  background-image: none;
  border-color: #bd841b !important;
  word-wrap: break-word;
  overflow: hidden;
  display: block;
  font-family: Sukhumvit;
}

.select-btn:hover {
  color: white !important;
  background-color: #bd841b !important;
  background-image: none;
  border-color: #bd841b !important;
}
</style>